"use strict";
/**
 * CAN THIS LOCATION BE USED YET?
 *
 * A tenant may create a location whenever they like; they may not trade from it
 * until it has been paid for and carries a subscription of its own. This is the
 * single rule that decides it, shared by every surface so the answer cannot
 * differ between the POS, the app and the API.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * FAIL OPEN, ALWAYS. THIS IS THE LOAD-BEARING PART.
 * ─────────────────────────────────────────────────────────────────────────────
 * Only an EXPLICIT `awaiting_payment` blocks. Anything else — `active`, absent,
 * unrecognised, a read that failed — is allowed.
 *
 * The inverse rule ("allow only a location that has a subscription") is the
 * obvious one and it is catastrophic: every location on the platform today is
 * `active` with NO subscription of its own, because legacy tenants bill one
 * tenant-level subscription for the whole account. That rule would lock every
 * existing store out of its own till on the day it deployed.
 *
 * So a location is blocked only because something deliberately marked it
 * unpaid, never because we could not prove it was paid.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCATION_BLOCKED_MESSAGE = exports.LOCATION_AWAITING_PAYMENT = void 0;
exports.isLocationAwaitingPayment = isLocationAwaitingPayment;
exports.isLocationBlocked = isLocationBlocked;
exports.LOCATION_AWAITING_PAYMENT = 'awaiting_payment';
/** True only for a location explicitly marked as not yet paid for. */
function isLocationAwaitingPayment(location) {
    return location?.status === exports.LOCATION_AWAITING_PAYMENT;
}
/**
 * Whether the till may be opened at this location.
 *
 * Deliberately the same shape as `isSellBlocked` for the tenant: a boolean with
 * one reason, so a caller cannot accidentally invert it.
 */
function isLocationBlocked(location) {
    return isLocationAwaitingPayment(location);
}
/**
 * What a CASHIER is told. They cannot fix billing, so it carries no amounts, no
 * invoice ids and no card detail — the same posture as the tenant-level gate.
 */
exports.LOCATION_BLOCKED_MESSAGE = 'This store is not open yet. Please ask your manager to finish setting it up.';
//# sourceMappingURL=locationAccess.js.map